(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', initAnchorNav);
  document.addEventListener('DOMContentLoaded', initPickyCards);
  document.addEventListener('DOMContentLoaded', initReveals);
  document.addEventListener('DOMContentLoaded', initSectionViews);

  function initAnchorNav() {
    var nav = document.querySelector('[data-anchor-nav]');
    if (!nav) return;
    var links = Array.from(nav.querySelectorAll('a[href^="#"]'));
    if (!links.length) return;

    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var id = link.getAttribute('href').slice(1);
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + id);
      });
    });

    var sections = links
      .map(function (l) { return document.getElementById(l.getAttribute('href').slice(1)); })
      .filter(Boolean);

    if (!('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var id = entry.target.id;
        links.forEach(function (l) {
          l.classList.toggle('is-active', l.getAttribute('href') === '#' + id);
        });
      });
    }, { rootMargin: '-30% 0px -60% 0px', threshold: 0 });

    sections.forEach(function (s) { io.observe(s); });
  }

  function pushDataLayer(event, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: event }, payload || {}));
  }

  document.addEventListener('DOMContentLoaded', initCalculator);

  var calcRecompute = null;
  var calcWriteOutputs = null;

  // kcal per 16 oz pack. Variety has no entry on purpose: the box alternates
  // Chicken and Beef packs and no measured per-pack kcal exists, so we don't
  // invent one — Variety customers get their grid-based portion with no
  // recipe pill selected. Keep in lockstep with OnboardingDataAssembler.php.
  function kcalForRecipe(recipe) {
    if (recipe === 'Beef') return 554;
    return 516;
  }

  function initCalculator() {
    var form = document.querySelector('[data-calc-form]');
    if (!form) return;

    var weightEl = form.querySelector('[data-calc-weight]');
    var packsOut = document.querySelector('[data-calc-packs]');
    var ozOut = document.querySelector('[data-calc-oz]');
    var kcalOut = document.querySelector('[data-calc-kcal]');
    var splitEl = document.querySelector('[data-calc-split]');
    var halfAmOut = document.querySelector('[data-calc-half-am]');
    var halfPmOut = document.querySelector('[data-calc-half-pm]');

    function read() {
      var weight = clampWeight(parseFloat(weightEl.value));
      var recipeEl = form.querySelector('[data-calc-recipe]:checked');
      var activityEl = form.querySelector('[data-calc-activity]:checked');
      var puppyEl = form.querySelector('[data-calc-puppy]');
      return {
        weightLbs: weight,
        recipe: recipeEl ? recipeEl.value : 'Chicken',
        activity: activityEl ? activityEl.value : 'normal',
        isPuppy: !!(puppyEl && puppyEl.checked),
      };
    }

    function clampWeight(v) {
      if (!isFinite(v)) return 1;
      return Math.min(Math.max(v, 1), 200);
    }

    function writeOutputs(portion) {
      packsOut.textContent = formatPacks(portion.dailyPacks);
      ozOut.textContent = portion.dailyOz;
      kcalOut.textContent = portion.dailyKcal;

      // AM/PM split: each meal is exactly half the daily total. dailyPacks is
      // already quarter-rounded, so halves land on eighths (0.75 -> 0.375) and
      // need three decimals — formatPacks' two would round 0.375 to "0.38".
      if (splitEl) {
        var half = portion.dailyPacks / 2;
        if (half > 0) {
          splitEl.hidden = false;
          halfAmOut.textContent = formatHalfPack(half);
          halfPmOut.textContent = formatHalfPack(half);
        } else {
          // Sub-quarter-pack dogs round to 0 packs/day; a "feed 0 packs"
          // schedule is worse than no schedule.
          splitEl.hidden = true;
        }
      }
    }

    function recompute() {
      var s = read();
      var portion = computePortion(s.weightLbs, kcalForRecipe(s.recipe), s.activity, s.isPuppy);
      writeOutputs(portion);

      pushDataLayer('lander_calculator_change', {
        weightLbs: s.weightLbs,
        recipe: s.recipe,
        activity: s.activity,
        isPuppy: s.isPuppy,
        dailyPacks: portion.dailyPacks,
      });
    }

    calcRecompute = recompute;
    calcWriteOutputs = writeOutputs;

    var debounced = debounce(recompute, 250);
    form.addEventListener('input', debounced);
    form.addEventListener('change', debounced);
    recompute();
  }

  // Pet.activity arrives as LIGHT/MODERATE/HEAVY (the profile vocabulary);
  // the calculator radios use low/normal/high. Map before pre-selecting —
  // unmapped values used to leave the radio untouched for every non-MODERATE
  // dog (Trello #332).
  function activityToRadioValue(activity) {
    var map = {
      light: 'low', less: 'low', low: 'low',
      moderate: 'normal', normal: 'normal',
      heavy: 'high', high: 'high', very: 'high',
    };
    return map[String(activity || 'normal').toLowerCase()] || 'normal';
  }

  function syncCalculatorWithPet(pet) {
    var form = document.querySelector('[data-calc-form]');
    if (!form) return;
    var weightEl = form.querySelector('[data-calc-weight]');
    if (weightEl && typeof pet.weightLbs === 'number') {
      weightEl.value = String(pet.weightLbs);
    }
    // A recipe with no matching pill (Variety — no measured pack kcal)
    // leaves ALL pills unchecked rather than letting the markup's default
    // (Chicken) masquerade as the customer's plan.
    var recipeEl = form.querySelector('[data-calc-recipe][value="' + pet.recipe + '"]');
    form.querySelectorAll('[data-calc-recipe]').forEach(function (r) { r.checked = false; });
    if (recipeEl) recipeEl.checked = true;
    var activityEl = form.querySelector('[data-calc-activity][value="' + activityToRadioValue(pet.activity) + '"]');
    if (activityEl) activityEl.checked = true;
    var puppyEl = form.querySelector('[data-calc-puppy]');
    if (puppyEl) puppyEl.checked = !!pet.isPuppy;

    // On load the calculator shows the SERVER portion (the nutritionist grid
    // when the profile resolves to a row) so it can never disagree with the
    // hero or the member portal. The local RER formula takes over only once
    // the customer starts exploring (input/change events → recompute).
    if (typeof pet.dailyPacks === 'number' && typeof pet.dailyOz === 'number' && typeof pet.dailyKcal === 'number') {
      if (calcWriteOutputs) {
        calcWriteOutputs({ dailyPacks: pet.dailyPacks, dailyOz: pet.dailyOz, dailyKcal: pet.dailyKcal });
      }
      pushDataLayer('lander_calculator_change', {
        weightLbs: pet.weightLbs,
        recipe: pet.recipe,
        activity: pet.activity,
        isPuppy: !!pet.isPuppy,
        dailyPacks: pet.dailyPacks,
      });
    } else if (calcRecompute) {
      calcRecompute();
    }
  }

  /**
   * Daily portion math — must agree numerically with PHP PortionCalculator
   * (src/Service/Onboarding/PortionCalculator.php). Formula source: PRD §3.3
   * (TODO: vet sign-off). Canonical agreement: 68 lb / 554 kcal/pack /
   * normal / not-puppy → 1.75 packs / 28 oz / 970 kcal.
   */
  function computePortion(weightLbs, kcalPerPack, activity, isPuppy) {
    // Covers both the radio vocabulary (low/normal/high) and the profile's
    // (LIGHT/MODERATE/HEAVY) — keep in lockstep with PortionCalculator.php.
    var ACT = { low: 0.8, less: 0.8, light: 0.8, normal: 1.0, moderate: 1.0, high: 1.2, heavy: 1.2, very: 1.2 };
    activity = String(activity || 'normal').toLowerCase();
    var weightKg = weightLbs / 2.205;
    var rer = 70.0 * Math.pow(weightKg, 0.75);
    var factor = ACT[activity] != null ? ACT[activity] : 1.0;
    var mer = rer * factor;
    if (isPuppy) mer *= 2.5;
    var rawPacks = mer / kcalPerPack;
    var dailyPacks = Math.round(rawPacks * 4) / 4;
    return {
      dailyPacks: dailyPacks,
      dailyOz: Math.round(dailyPacks * 16),
      dailyKcal: Math.round(dailyPacks * kcalPerPack),
    };
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(null, args); }, ms);
    };
  }

  function initPickyCards() {
    var cards = document.querySelectorAll('[data-picky-card]');
    if (!cards.length) return;
    cards.forEach(function (c) { c.open = false; });
  }

  document.addEventListener('DOMContentLoaded', initPortalCtas);

  function initPortalCtas() {
    var ctas = document.querySelectorAll('[data-portal-cta]');
    if (!ctas.length) return;

    var inboundUtm = collectUtmParams();

    ctas.forEach(function (cta) {
      var base = cta.getAttribute('href') || '';
      if (inboundUtm) {
        var sep = base.indexOf('?') === -1 ? '?' : '&';
        cta.setAttribute('href', base + sep + inboundUtm);
      }
      cta.addEventListener('click', function () {
        pushDataLayer('lander_portal_cta_click', { placement: cta.getAttribute('data-portal-placement') || 'unknown' });
      });
    });
  }

  function collectUtmParams() {
    var params = new URLSearchParams(window.location.search);
    var keep = [];
    ['utm_source','utm_medium','utm_campaign','utm_term','utm_content'].forEach(function (k) {
      var v = params.get(k);
      if (v) keep.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
    });
    return keep.join('&');
  }

  function initReveals() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.querySelectorAll('[data-reveal-item]').forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-reveal-item]').forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var siblings = entry.target.parentNode.querySelectorAll('[data-reveal-item]');
        siblings.forEach(function (el, i) {
          setTimeout(function () { el.classList.add('is-revealed'); }, i * 80);
        });
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px' });

    document.querySelectorAll('[data-reveal] > [data-reveal-item]:first-child').forEach(function (el) {
      io.observe(el);
    });
  }

  function initSectionViews() {
    if (!('IntersectionObserver' in window)) return;
    var sections = document.querySelectorAll('section[id]');
    if (!sections.length) return;
    var seen = new Set();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        if (seen.has(entry.target.id)) return;
        seen.add(entry.target.id);
        pushDataLayer('lander_section_view', { section: entry.target.id });
      });
    }, { threshold: 0.5 });
    sections.forEach(function (s) { io.observe(s); });
  }

  document.addEventListener('DOMContentLoaded', initHeroHydration);

  function initHeroHydration() {
    var section = document.getElementById('dd-onboarding');
    if (!section) return;
    var endpoint = section.getAttribute('data-onboarding-endpoint');
    if (!endpoint) return;
    var hero = document.querySelector('.dd-on__hero');

    function settleAnonymous(reason) {
      if (hero && hero.getAttribute('data-state') !== 'logged-in') {
        hero.setAttribute('data-state', 'anonymous');
      }
      if (reason) pushDataLayer('lander_personalization_skipped', { reason: reason });
    }

    fetch(endpoint, { credentials: 'include', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !Array.isArray(data.pets) || data.pets.length === 0) {
          settleAnonymous(data ? 'no_pets' : 'fetch_not_ok');
          return;
        }
        renderLoggedInHero(data.pets);
      })
      .catch(function () {
        settleAnonymous('fetch_error');
      });
  }

  var PHASE_TO_CARD_INDEX = {
    start_small: 0,
    half_it: 1,
    almost_there: 2,
    complete: 3,
  };

  function renderLoggedInHero(pets) {
    var section = document.getElementById('dd-onboarding');
    section.setAttribute('data-state', 'logged-in');
    var hero = document.querySelector('.dd-on__hero');
    if (hero) hero.setAttribute('data-state', 'logged-in');

    var pillsRoot = document.querySelector('[data-hero-pets]');
    pillsRoot.hidden = false;
    pillsRoot.innerHTML = '';
    var ghost = document.querySelector('[data-hero-ghost]');
    if (ghost) ghost.hidden = true;
    var statCard = document.querySelector('[data-stat-card]');
    if (statCard) statCard.hidden = false;

    // Default to the first pet with an active subscription. Falls back
    // to index 0 so customers whose subs are all paused/cancelled still
    // see something (their most recent meal-plan recipe).
    var defaultIdx = pets.findIndex(function (p) { return p.subscriptionLinked === true; });
    if (defaultIdx < 0) defaultIdx = 0;

    pets.forEach(function (pet, idx) {
      var btn = document.createElement('button');
      btn.className = 'dd-on__pill';
      btn.type = 'button';
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-selected', idx === defaultIdx ? 'true' : 'false');
      btn.setAttribute('tabindex', idx === defaultIdx ? '0' : '-1');
      btn.innerHTML = escapeHtml(pet.name) + ' <span class="dd-on__pill-meta">· ' + escapeHtml(String(pet.weightLbs)) + ' lbs</span>';
      btn.addEventListener('click', function () { selectPet(pets, idx); });
      btn.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var next = (idx + (e.key === 'ArrowRight' ? 1 : pets.length - 1)) % pets.length;
        var btns = pillsRoot.querySelectorAll('.dd-on__pill');
        btns[next].focus();
        selectPet(pets, next);
      });
      pillsRoot.appendChild(btn);
    });

    selectPet(pets, defaultIdx);
  }

  function selectPet(pets, idx) {
    var pet = pets[idx];
    var pillsRoot = document.querySelector('[data-hero-pets]');
    pillsRoot.querySelectorAll('.dd-on__pill').forEach(function (b, i) {
      b.setAttribute('aria-selected', i === idx ? 'true' : 'false');
      b.setAttribute('tabindex', i === idx ? '0' : '-1');
    });
    pet.mixToday = computeMix(pet.dailyPacks, pet.transitionRatio);
    renderStatCard(pet);
    renderTransitionProgress(pet);
    syncCalculatorWithPet(pet);
    pushDataLayer('lander_pet_pill_select', { petIndex: idx, petName: pet.name });
  }

  function renderTransitionProgress(pet) {
    var panel = document.querySelector('[data-transition-progress]');
    if (!panel) return;

    var cards = document.querySelectorAll('.dd-on__t-card');
    cards.forEach(function (c) { c.classList.remove('is-active'); });

    var phase = pet.transitionPhase;
    var day = pet.transitionDay;
    if (!phase || phase === 'steady' || !day) {
      panel.hidden = true;
      return;
    }

    panel.hidden = false;

    var numEl = panel.querySelector('[data-progress-num]');
    if (numEl) numEl.textContent = pad(day);

    var petEl = panel.querySelector('[data-progress-pet]');
    if (petEl) petEl.textContent = pet.name + ' · ' + pet.weightLbs + ' lbs';

    var phaseEl = panel.querySelector('[data-progress-phase]');
    if (phaseEl) phaseEl.textContent = phaseLabel(phase);

    var barEl = panel.querySelector('[data-progress-bar]');
    if (barEl) {
      barEl.innerHTML = '';
      for (var i = 1; i <= 10; i++) {
        var li = document.createElement('li');
        if (i < day) li.classList.add('is-done');
        else if (i === day) li.classList.add('is-current');
        barEl.appendChild(li);
      }
    }

    var noteEl = panel.querySelector('[data-progress-note]');
    if (noteEl) {
      var mix = pet.mixToday;
      noteEl.innerHTML = 'Today: <strong>' + mix.dash + ' packs</strong> Dash · <strong>' + mix.old + ' packs</strong> old food.';
    }

    var cardIdx = PHASE_TO_CARD_INDEX[phase];
    if (cardIdx !== undefined && cards[cardIdx]) {
      cards[cardIdx].classList.add('is-active');
    }
  }

  function computeMix(totalPacks, ratio) {
    if (!ratio) return { dash: totalPacks, old: 0 };
    return {
      dash: roundQuarter(totalPacks * (ratio.dash / 100)),
      old:  roundQuarter(totalPacks * (ratio.old / 100)),
    };
  }
  function roundQuarter(v) { return Math.round(v * 4) / 4; }
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function renderStatCard(pet) {
    var card = document.querySelector('[data-stat-card]');
    if (!card) return;

    var portionTile =
      '<div>' +
        '<div class="dd-on__stat-tile-label">Daily portion</div>' +
        '<div class="dd-on__stat-tile-value">' + formatPacks(pet.dailyPacks) + '</div>' +
        '<div class="dd-on__stat-tile-sub">packs · ' + pet.dailyOz + ' oz · ~' + pet.dailyKcal + ' kcal</div>' +
      '</div>';

    var transitionTile;
    if (pet.transitionPhase && pet.transitionPhase !== 'steady') {
      var pct = pet.transitionRatio ? pet.transitionRatio.dash : 100;
      transitionTile =
        '<div>' +
          '<div class="dd-on__stat-tile-label">Transition</div>' +
          '<div class="dd-on__stat-tile-value">' + pet.transitionDay + '<span class="dd-on__h1-ital"> of </span>10</div>' +
          '<div class="dd-on__stat-tile-sub">' + phaseLabel(pet.transitionPhase) + '</div>' +
          '<div class="dd-on__progress"><span style="width:' + pct + '%"></span></div>' +
        '</div>';
    }

    var noSub = pet.subscriptionLinked
      ? ''
      : '<div class="dd-on__stat-no-sub">Once your subscription starts, your transition timeline appears here.</div>';

    var badge = pet.transitionPhase === 'complete'
      ? '<span class="dd-on__badge-complete">✓ Complete</span>'
      : '';

    // "Variety Pack" is the product's name; "Variety Recipe" is not.
    var planLabel = pet.recipe === 'Variety' ? 'Variety Pack' : pet.recipe + ' Recipe';

    card.innerHTML =
      '<div class="dd-on__stat-eyebrow"><span>&nbsp;Today\'s plan · ' + escapeHtml(planLabel) + '</span>' + badge + '</div>' +
      '<div class="dd-on__stat-tiles" style="' + (transitionTile ? '' : 'grid-template-columns:1fr;') + '">' +
        portionTile + (transitionTile || '') +
      '</div>' +
      noSub;
  }

  function phaseLabel(phase) {
    return {
      start_small: 'Start Small phase',
      half_it: 'Half It phase',
      almost_there: 'Almost There phase',
      complete: 'Final day',
      steady: 'Steady state',
    }[phase] || '';
  }
  function formatPacks(p) { return trimTrailingZeros(p.toFixed(2)); }

  // Half-portions land on eighths (0.125 / 0.375 / 0.625 / 0.875), so they
  // need a third decimal that formatPacks would round away.
  function formatHalfPack(p) { return trimTrailingZeros(p.toFixed(3)); }

  function trimTrailingZeros(s) { return s.replace(/\.?0+$/, ''); }
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }
})();
